<template>
  <main class="page success-page">
    <section class="success-content">
      <img
        class="success-illustration"
        src="https://static.91fd.com/tonghui_life/sell_on_credit_20201210/success.png"
        alt="申请提交成功"
      />
      <h1>您的分期申请提交成功！</h1>

      <div class="phone">
        <div class="phone-screen">
          <img src="../assets/images/ssx_qrcode.jpg" alt="申申享公众号二维码" />
        </div>
      </div>

      <p class="qr-tip">长按识别二维码关注公众号</p>
      <p class="description">
        关注公众号，点击底部“我的订单-个人中心”<br />
        登录接收订单详情通知。
      </p>
    </section>
  </main>
</template>

<script>
export default {
  name: "SubmissionSuccess",
};
</script>

<style lang="scss" scoped>
.success-page {
  min-height: 100vh;
  padding: 72px 20px 32px;
  background: #fff;
  color: #242c33;
}
.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.success-illustration {
  display: block;
  width: 128px;
  height: 102px;
  object-fit: contain;
}
h1 {
  margin: 12px 0 8px;
  color: #535353;
  font-size: 20px;
  font-weight: normal;
  line-height: 30px;
}
.phone {
  display: flex;
  width: 222px;
  height: 182px;
  align-items: center;
  justify-content: center;
  margin-top: 11px;
}
.phone-screen {
  width: 184px;
  height: 184px;
  padding: 8px;
  border: 1px solid #e1a379;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 24px 4px rgba(211, 147, 106, 0.38);
}
.phone-screen img {
  display: block;
  width: 164px;
  height: 164px;
  object-fit: contain;
}
.qr-tip {
  display: flex;
  height: 26px;
  align-items: center;
  margin: 17px 0 0;
  padding: 0 18px;
  border-radius: 19px;
  background: #e1a379;
  color: #fff;
  font-size: 13px;
  line-height: 38px;
}
.description {
  margin: 7px 0 0;
  font-size: 12px;
  line-height: 17px;
}
</style>
